import { useLayoutEffect, useState } from 'react';
import routes from '../defaultLayout/routes';
import ServerConfigModal from '../ServerConfigModal/ServerConfigModal';
import { useServerConfig } from '../../config/useConfig';
import './navBar.scss';

const NavBar = () => {
    const [currentPath, setCurrentPath] = useState('');
    const [showServerConfig, setShowServerConfig] = useState(false);
    const { serverConfig } = useServerConfig();
    const height = window.innerHeight;

    useLayoutEffect(() => {
        // eslint-disable-next-line no-restricted-globals
        setCurrentPath(location.pathname);
    }, []);

    const onClickHandler = (path: string) => {
        window.location.href = path
    };

    const handleServerConfigClick = () => {
        setShowServerConfig(true);
    };

    const handleServerConfigClose = () => {
        setShowServerConfig(false);
    };

    return (
        <div id="nav_bar" style={{ minHeight: height }}>
            <div className="title">Pages</div>
            <div className="nav_wrapper">
                {routes.map((route) => {
                    const { name, path } = route;
                    if (path.length < 2) return undefined; // skip this one
                    if (path === '/reportTestPage') return null
                    return (
                        <span
                            key={name}
                            className={`nav_item${path === currentPath ? ' active' : ''}`}
                            onClick={() => onClickHandler(path)}
                        >
                            {name}
                        </span>
                    );
                })}
            </div>
            
            <div className="server-config-section">
                <div className="current-server">
                    <span className="server-label">Server:</span>
                    <span className="server-url">{`${serverConfig.protocol}://${serverConfig.host}:${serverConfig.port}`}</span>
                </div>
                <button 
                    className="server-config-button"
                    onClick={handleServerConfigClick}
                    title="Configure server settings"
                >
                    ⚙️ Settings
                </button>
            </div>

            <ServerConfigModal 
                isOpen={showServerConfig}
                onClose={handleServerConfigClose}
                onConfigChange={() => {
                    // Force a page reload to apply new server settings
                    window.location.reload();
                }}
            />
        </div>
    );
};

export default NavBar;
